<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="header"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <p class="text-gray-500 dark:text-gray-300 mb-3">{{ message }}</p>
    <p-iftalabel>
        <textarea pTextarea id="comment" [(ngModel)]="comment" rows="3" style="resize: none" class="w-full"></textarea>
        <label for="comment">Comment (optional)</label>
    </p-iftalabel>
    <div class="flex items-center justify-end gap-2 mt-6">
        <p-button label="Cancel" (onClick)="onReject()" severity="secondary"></p-button>
        <p-button label="Confirm" (onClick)="onAccept()" severity="primary"></p-button>
    </div>
</p-dialog>
